module.exports = __webpack_public_path__ + "static/Samagra_Logo_updated-f59ec74c713638ada10b837a71238eaa.svg";